<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="addBox = true"
          >新增</el-button
        >
      </div>
    </div>

    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                responseData.pageSize * (responseData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="positionTitle" label="职务名称" align="center">
          </el-table-column>
          <el-table-column
            prop="members"
            label="成员"
            align="center"
            width="200"
          >
            <template slot-scope="rowData">
              {{ rowData.row.members }}人
            </template>
          </el-table-column>
          <el-table-column
            prop="addtime"
            label="创建时间"
            width="200"
            align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.addtime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="openEditBox(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="delJob(scope.row.id)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="getUserList(scope.row.id)"
                      :underline="false"
                      >成员列表</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="openAddBox(scope.row.id)"
                      :underline="false"
                      >添加成员</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="responseData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增数据 -->
    <el-dialog
      title="新增职务"
      :visible.sync="addBox"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
    >
      <el-form label-width="80px">
        <el-form-item label="职务名称">
          <el-input
            v-model.trim="addData.positionTitle"
            placeholder="请填写职务名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addBox = false">取 消</el-button>
        <el-button type="primary" @click="addDataAction()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑数据 -->
    <el-dialog
      title="编辑职务"
      :visible.sync="editBox"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
    >
      <el-form label-width="80px">
        <el-form-item label="职务名称">
          <el-input
            v-model.trim="editData.positionTitle"
            placeholder="请填写职务名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editBox = false">取 消</el-button>
        <el-button type="primary" @click="editDataAction()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加成员"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      :before-close="handleClose"
      :visible.sync="showDialog"
      direction="ltr"
    >
      <div
        style="display: flex;
      justify-content: center;
      align-items: center;"
      >
        <el-transfer
          v-model="selectedMemberList"
          :props="{
            key: 'userId',
            label: 'userName',
            disabled: 'disabled'
          }"
          :titles="['待选择成员列表', '待提交成员列表']"
          :data="departmentHead"
          filterable
          :filter-method="filterMethod"
          filter-placeholder="请输入成员名称"
        >
          <el-button
            class="transfer-footer"
            type="primary"
            style="float:right;margin:5px"
            slot="right-footer"
            size="small"
            :disabled="selectedMemberList.length > 0 ? false : true"
            @click="addJobPersonnel()"
            >提交</el-button
          >
        </el-transfer>
      </div>
    </el-dialog>
    <job-table-dialog
      :showDialog="jShow"
      :jobId="jobId"
      @close="jClose"
    ></job-table-dialog>
  </div>
</template>

<script>
import JobStructure from "@/components/JobStructure";
import JobTableDialog from "./components/JobTableDialog.vue";
export default {
  name: "",
  components: { JobStructure, JobTableDialog },
  data() {
    return {
      props: {
        multiple: true,
        expandTrigger: "hover"
      },

      listBox: true,
      addBox: false,
      editBox: false,
      detailsBox: false,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
        type: 0
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: []
      },

      addData: {
        positionTitle: "",
        schoolId: this.$store.state.schoolId
      },

      editData: {
        id: "",
        positionTitle: ""
      },

      jobDetailsList: [],
      jobDetailsData: {},
      delDataList: [],
      // 部门负责人
      departmentHead: [],
      addMemberList: [],
      selectedMemberList: [],
      showDialog: false,
      filterMethod(query, item) {
        return item.userName.indexOf(query) > -1;
      },
      jShow: false,
      jobId: "",
      positionId: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 获取部门及部门人员
    async getDepartmentHead() {
      var paramData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        let data = res.data || [];
        let newData = [];
        data.forEach((item, index) => {
          if (item.dlist.length > 0) {
            newData.push.apply(newData, item.dlist);
          }
        });
        if (this.jobDetailsList.length > 0) {
          this.jobDetailsList.forEach((item, index) => {
            newData.forEach((iitem, iindex) => {
              if (item.userId == iitem.userId) {
                iitem.disabled = true;
              }
            });
          });
          this.departmentHead = newData;
        } else {
          this.departmentHead = newData;
        }
      } else if (res.code == 101) {
        this.departmentHead = [];
      } else {
        this.departmentHead = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 删除成员数据
    delMemberData(type, data) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let requestData = [];
          if (type == 1) {
            requestData = data;
          } else {
            requestData = [data];
          }
          let res = await this.$Http.delSchoolJobMember(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataDetails(this.jobDetailsData);
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 添加职务人员
    async addJobPersonnel() {
      let self = this;
      var newParamData = Object.assign([], this.selectedMemberList);
      if (this.selectedMemberList.length < 1) {
        this.$message({
          type: "warning",
          message: "请先选择您要添加的人员"
        });
        return false;
      }
      let req = newParamData.map((item) => {
        return {
          positionId: this.jobDetailsData.id,
          userId: item
        };
      });
      let res = await this.$Http.addSchoolJobMember(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.selectedMemberList = [];
        this.getDataList();
        this.showDialog = false;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取数据列表
    async getDataList() {
      var newParamData = this.requestData;
      let res = await this.$Http.getSchoolJobList(newParamData, true);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    delJob(id) {
      this.$confirm("此操作将永久删除该职务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delSchoolJobData(id);
        })
        .catch(() => {});
    },
    // 删除职务
    async delSchoolJobData(id) {
      let req = {
        positionId: id
      };
      let res = await this.$Http.delSchoolJobData(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 新增数据
    async addDataAction() {
      if (this.addData.positionTitle == "") {
        this.$message("请填写职务!");
        return;
      }
      var newParamData = Object.assign({}, this.addData);
      let res = await this.$Http.addSchoolJobData(newParamData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.addData.positionTitle = "";
        this.addBox = false;
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 编辑数据
    async editDataAction() {
      var newParamData = Object.assign({}, this.editData);
      let res = await this.$Http.editSchoolJobData(newParamData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.editBox = false;
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取数据详情
    async getDataDetails(thisData) {
      this.jobDetailsData = thisData;
      var newParamData = {
        id: thisData.id
      };
      let res = await this.$Http.getSchoolJobDetails(newParamData, true);
      this.getDepartmentHead();
      if (res.code == 200) {
        // console.log(res.data)
        this.jobDetailsList = [];
        if (res.data) {
          this.jobDetailsList = res.data;
          // console.log(this.jobDetailsList)
        }
        this.listBox = false;
        this.detailsBox = true;
      } else if (res.code == 101) {
        this.detailsBox = true;
        this.listBox = false;
        this.jobDetailsList = [];
      } else {
        this.detailsBox = true;
        this.listBox = false;
        this.jobDetailsList = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getDataList();
    },

    // 打开编辑
    openEditBox(thisData) {
      this.editData.id = thisData.id;
      this.editData.positionTitle = thisData.positionTitle;
      this.editBox = true;
    },
    openAddBox(id) {
      this.jobDetailsData.id = id;
      this.getDepartmentHead();
      this.showDialog = true;
    },
    handleClose() {
      this.showDialog = false;
    },
    getUserList(id) {
      this.jobId = id + "";
      this.jShow = true;
    },
    jClose() {
      this.jShow = false;
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>
<style scoped></style>
